/**
 * API 服务器配置
 */

export const apiConfig = {
  port: process.env.WORKFLOW_API_PORT ? parseInt(process.env.WORKFLOW_API_PORT) : 3456,
  basePath: '/api',
  version: 'v2',
  
  // SSE 配置
  sse: {
    heartbeatInterval: 30000, // 30秒心跳
    maxConnections: 100,
    reconnectDelay: 5000,
  },
  
  // CORS 配置
  cors: {
    allowedOrigins: process.env.WORKFLOW_CORS_ORIGINS
      ? process.env.WORKFLOW_CORS_ORIGINS.split(',')
      : ['http://localhost:5173', 'http://localhost:3000'],
  },
  
  // 速率限制配置
  rateLimit: {
    windowMs: 15 * 60 * 1000, // 15分钟
    max: 100, // 最多100个请求
    message: 'Too many requests from this IP',
  },
};

// API 版本信息
export const API_VERSIONS = {
  current: 'v2',
  supported: ['v1', 'v2'],
  deprecated: ['v1'],
  sunset: {
    v1: '2025-12-31',
  },
};